import React, { Suspense, lazy } from 'react';
import PageSkeleton from 'Components/DesignSystem/PageSkeleton/PageSkeleton';

const AnalyticsProvider = lazy(() => import('./AnalyticsProvider'));

const AnalyticsProviderLazy = (props: any) => (
  <Suspense fallback={<PageSkeleton preset="list" label="Loading performance" data-testid="analytics-lazy-loading" />}>
    <AnalyticsProvider {...props} />
  </Suspense>
);

export default AnalyticsProviderLazy;
